import axios from "axios";
//getEmployeeBioData
import {
	MASTERDATA_LOADING,
	MASTERDATA_SAVING_FAILED,
	MASTERDATA_SAVING_SUCCESSED,
} from "./types";
export const loadBioDataMaster = (listdata) => (dispatch) => {
	dispatch({ type: MASTERDATA_LOADING });

	let formData = new FormData(); //formdata object
	console.log("loadNotifications data=", listdata);

	listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			dispatch({ type: MASTERDATA_SAVING_SUCCESSED, payload: response });

			console.log("loadNotifications=", response);
		})
		.catch((error) => {
			console.log(error);
			return dispatch({
				type: MASTERDATA_SAVING_FAILED,
				payload: error,
			});
		});
};
